import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NewsfeedState } from './newsfeed.state';
import { getDefaultFeedOrigin } from '../tenant-state/tenant.selectors';
import { INITIAL_NEWSFEED_FILTERS } from '../../declarations/filter.interface';

const getFeatureState = createFeatureSelector<NewsfeedState>('newsfeedState');

export const getCurrentNewsfeedFilters = createSelector(
  getFeatureState,
  (state: NewsfeedState) => state.currentNewsfeedFilters
);

export const isNewsfeedFilterActive = createSelector(
  getFeatureState,
  getDefaultFeedOrigin,
  (state: NewsfeedState, initialOrigin: 'my_settlement' | 'all') => {
    const filters = state.currentNewsfeedFilters;
    return (
      filters.filterByGroup.length !== 0 ||
      filters.filterByType.length !==
        INITIAL_NEWSFEED_FILTERS.filterByType.length ||
      filters.origin !== initialOrigin ||
      filters.myPostsOnly !== INITIAL_NEWSFEED_FILTERS.myPostsOnly ||
      filters.highlightedOnly !== INITIAL_NEWSFEED_FILTERS.highlightedOnly
    );
  }
);
